import { SubMemberType, UTA_STATUS } from './constants/sub-account';

const CREATE_API_PAGE_PATH = '/app/user/add-secret-key';
const EDIT_API_PAGE_PATH = '/app/user/edit-secret-key';

// 导航到API列表页
export const navigateToAPiPage = (
  params: (
    | {
        isSubAccount: boolean;
        subAccountMemberId: string;
        subAccountLoginName: string;
        subAccountMemberType: string;
        subAccountMemberStatus: string[];
        subAccountMemberTag: string;
        isUta?: keyof typeof UTA_STATUS;
      }
    | Record<string, never>
  ) & { navigate?: (href: string) => void },
) => {
  const path = params.isSubAccount
    ? '/app/user/subaccount-api-management'
    : '/app/user/api-management';
  let search = '';
  if (params.isSubAccount) {
    const {
      subAccountMemberId,
      subAccountLoginName,
      subAccountMemberType,
      subAccountMemberStatus,
      subAccountMemberTag,
    } = params;

    search = `?subaccount_id=${subAccountMemberId}&name=${subAccountLoginName}&memberType=${subAccountMemberType}${
      subAccountMemberTag && `&member_tag=${subAccountMemberTag}`
    }`;
    if (subAccountMemberStatus.length) {
      search += `&memberStatus=${subAccountMemberStatus.join(',')}`;
    }
  }
  const href = `${path}${search}`;
  if (params.navigate) {
    params.navigate(href);
  } else {
    window.location.href = href;
  }
};

// 导航到子账号创建API页面
export const navigateToSubAccountCreateApiPage = ({
  subAccountId,
  subAccountLoginName,
  subAccountMemberTag,
  subAccountMemberType,
  subAccountMemberStatus,
  type,
}: {
  subAccountId: string; // 子账号ID
  subAccountLoginName: string; // 子账号登录名
  subAccountMemberTag: string; // 子账号标签，目前只有uta升级状态(2024-04-15)
  subAccountMemberType: SubMemberType; // 子账号类型
  subAccountMemberStatus: string; // 子账号状态，目前只有 copytrading 账号升级状态(2024-04-15)
  type: 'system' | 'auto' | string; // API类型
  isToEdit: boolean; // 是否导航到编辑页面
}) => {
  const memberTag = subAccountMemberTag
    ? `&member_tag=${subAccountMemberTag}`
    : '';
  let url = `${CREATE_API_PAGE_PATH}?subaccount_id=${subAccountId}&name=${subAccountLoginName}&type=${type}${memberTag}`;
  if (subAccountMemberType) {
    url += `&memberType=${subAccountMemberType}`;
  }
  if (subAccountMemberStatus) {
    url += `&memberStatus=${subAccountMemberStatus}`;
  }
  window.location.href = url;
};

// 导航到母账号创建API页面
export const navigateToMainAccountCreateApiPage = ({
  type,
}: {
  type: 'system' | 'auto' | string; // API类型
  isToEdit: boolean; // 是否导航到编辑页面
}) => {
  window.location.href = `${CREATE_API_PAGE_PATH}?type=${type}`;
};

// 导航到子账号编辑API页面
export const navigateToSubAccountEditApiPage = ({
  subAccountId,
  subAccountLoginName,
  subAccountMemberTag,
  subAccountMemberType,
  subAccountMemberStatus,
  apiManagementId,
  navigate,
}: {
  subAccountId: string; // 子账号ID
  subAccountLoginName: string; // 子账号登录名
  subAccountMemberTag: string; // 子账号标签，目前只有uta升级状态(2024-04-15)
  subAccountMemberType: SubMemberType; // 子账号类型
  subAccountMemberStatus: string; // 子账号状态，目前只有 copytrading 账号升级状态(2024-04-15)
  apiManagementId: string;
  navigate?: (href: string) => void;
}) => {
  const memberTag = subAccountMemberTag
    ? `&member_tag=${subAccountMemberTag}`
    : '';
  let url = `${EDIT_API_PAGE_PATH}?apiManagementId=${apiManagementId}${memberTag}`;
  url += `&subAccountId=${subAccountId}&name=${subAccountLoginName}`;
  if (subAccountMemberType) {
    url += `&memberType=${subAccountMemberType}`;
  }
  if (subAccountMemberStatus) {
    url += `&memberStatus=${subAccountMemberStatus}`;
  }
  if (navigate) {
    navigate(url);
  } else {
    window.location.href = url;
  }
};

// 导航到母账号编辑API页面
export const navigateToAPiEditPage = ({
  apiManagementId,
  navigate,
}: {
  apiManagementId: string;
  navigate?: (href: string) => void;
}) => {
  const url = `${EDIT_API_PAGE_PATH}?apiManagementId=${apiManagementId}`;
  if (navigate) {
    navigate(url);
  } else {
    window.location.href = url;
  }
};
